import React, { Component } from "react";
import { Spin, Modal } from "antd";
import moment from "moment";
import {
  history,
  showErrorNotification,
  strings,
  showSuccessNotification
} from "../../helpers";
import PromoCodeListView from "./PromoCodeListView";
import PromoCodeModal from "./PromoCodeModal";
import { getPromoCodeList, deletePromoCode } from "../../services";
const confirm = Modal.confirm;
export default class PromoCodeListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersList: [],
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      searchText: "",
      filterBy: "",
      showAddModal: false,
      selectedRecord: {}
    };
  }

  componentDidMount() {
    this.fetchUsersList();
  }

  /**
   * @function fetchUsersList
   * @description This function get doctors data
   */
  fetchUsersList = () => {
    const { pageNo } = this.state;
    this.setState({
      isProcessing: true
    });
    getPromoCodeList(pageNo)
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const { billing_promo_codes } = response.data.data;
          const { total_records } = response.data.data;
          const { total_pages } = response.data.data;
          this.setState({
            promoCodeList: billing_promo_codes,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            promoCodeList: [],
            isProcessing: false,
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ promoCodeList: [], isProcessing: false });
      });
  };

  /**
   * @function deletePromoCodeFromList
   * @description This function get doctors data
   */
  deletePromoCode = (name, id) => {
    const _this = this;
    confirm({
      okText: "Delete",
      title: `Do you want to delete ${name} promo code ?`,
      content: "",
      onOk() {
        _this.setState({ isProcessing: true });
        deletePromoCode(id)
          .then(response => {
            _this.setState({
              isProcessing: false
            });
            if (response.data.success) {
              showSuccessNotification("Promo code deleted successfully.");
              _this.fetchUsersList();
            } else {
              _this.setState({
                isProcessing: false
              });
            }
          })
          .catch(() => {
            showErrorNotification(strings.error_msg);
            _this.setState({ promoCodeList: [], isProcessing: false });
          });
      },
      onCancel() {}
    });
  };

  /**
   * @function onPageChange
   * @oaram page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, promoCodeList: [] }, () => {
      this.fetchUsersList();
    });
  };

  /**
   * @function showAddModal
   * @description it will show the modal
   */
  toggleAddModal = () => {
    const { showAddModal } = this.state;
    this.setState({ showAddModal: !showAddModal, selectedRecord: {} });
  };

  /**
   * @function toggleIsProcessing
   * @description it will change the processing.
   */
  toggleIsProcessing = () => {
    const { isProcessing } = this.state;
    this.setState({ isProcessing: !isProcessing });
  };

  /**
   * @function disabledDate
   * @param current
   * @desc This method disables 'Today' button,
   * if current date is selected from filter
   */
  disabledDate = current => current < moment().endOf("day");

  /**
   * @function refreshPromoCodeList
   * @desc This method disables 'Today' button,
   * if current date is selected from filter
   */
  refreshPromoCodeList = () => {
    this.fetchUsersList();
  };

  /**
   * @function stopIsProcessing
   * @description it will change the processing.
   */
  stopIsProcessing = () => {
    this.setState({ isProcessing: false });
  };

  openEditPromoCodeModal = (e, selectedRecord) => {
    e.preventDefault();

    this.setState({ showAddModal: true, selectedRecord });
  };

  render() {
    const {
      promoCodeList,
      isProcessing,
      totalRecords,
      totalPages,
      pageNo,
      searchText,
      filterBy,
      showAddModal,
      selectedRecord
    } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <PromoCodeListView
          openEditPromoCodeModal={this.openEditPromoCodeModal}
          deletePromoCode={this.deletePromoCode}
          toggleAddModal={this.toggleAddModal}
          navigateToUsersDetails={this.navigateToUsersDetails}
          promoCodeList={promoCodeList}
          allRecords={totalRecords}
          allPages={totalPages}
          pageNo={pageNo}
          onPageChange={this.onPageChange}
          searchText={searchText}
          handleSearchText={this.handleSearchText}
          handleSearch={this.handleSearch}
          filterBy={filterBy}
          handleFilterBy={this.handleFilterBy}
        />
        <PromoCodeModal
          handleUpdatePromo={this.handleUpdatePromo}
          selectedRecord={selectedRecord}
          stopIsProcessing={this.stopIsProcessing}
          refreshPromoCodeList={this.refreshPromoCodeList}
          toggleIsProcessing={this.toggleIsProcessing}
          disabledDate={this.disabledDate}
          showAddModal={showAddModal}
          toggleAddModal={this.toggleAddModal}
        />
      </Spin>
    );
  }
}
